<script setup lang="ts">

const {data, get:fetchFavIcon}=useOFetchCustom(`settings/favicon`)

 const favicon = ref<string>('')

 onMounted(()=>{
  fetchFavIcon(undefined,{
    onSuccess:()=>{
      favicon.value = data.value
      useHead({
      link: [
        { rel: 'icon', type: 'image/x-icon', href: favicon.value }
        ]
      });
    },
    headers:{
      'Content-Type': 'image/x-icon'
    }
  })
 })



</script>


<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>

<style>
.page-enter-active,
.page-leave-active {
    transition: all 0.5s;
}
.page-enter-from,
.page-leave-to {
    opacity: 0;
    filter: blur(1rem);
}

.layout-enter-active,
.layout-leave-active {
    transition: all 0.5s;
}
.layout-enter-from,
.layout-leave-to {
    filter: blur(1rem);
}
</style>
